import {
  mdiArrowLeft,
  mdiArrowUp,
  mdiArrowDown,
  mdiAccountOutline,
  mdiHelpCircleOutline,
  mdiHammer,
  mdiMagnify,
  mdiClose,
  mdiInformation,
  mdiCogOutline,
  mdiPencilOutline,
  mdiChevronDown,
  mdiChevronRight,
  mdiChevronLeft,
  mdiMore,
  mdiPencil,
  mdiPlus,
  mdiShare,
  mdiContentCopy,
  mdiDownloadOutline,
  mdiEyeOff,
  mdiEye,
  mdiFileDocumentEdit,
  mdiUnfoldMoreHorizontal,
  mdiAccountCogOutline,
  mdiAccountCircle,
  mdiWalletOutline,
  mdiAccountBox,
  mdiForumOutline,
  mdiHelpCircle,
  mdiTextBoxOutline,
  mdiSwapVertical,
  mdiReload,
  mdiAlert
} from "@mdi/js";

const icons = {
  mdiChevronLeft,
  mdiClose,
  mdiMagnify,
  mdiHammer,
  mdiArrowLeft,
  mdiArrowUp,
  mdiArrowDown,
  mdiAccountOutline,
  mdiHelpCircleOutline,
  mdiInformation,
  mdiCogOutline,
  mdiPencilOutline,
  mdiChevronDown,
  mdiChevronRight,
  mdiMore,
  mdiPencil,
  mdiPlus,
  mdiShare,
  mdiContentCopy,
  mdiDownloadOutline,
  mdiEyeOff,
  mdiEye,
  mdiFileDocumentEdit,
  mdiUnfoldMoreHorizontal,
  mdiAccountCogOutline,
  mdiAccountCircle,
  mdiWalletOutline,
  mdiAccountBox,
  mdiForumOutline,
  mdiHelpCircle,
  mdiTextBoxOutline,
  mdiSwapVertical,
  mdiReload,
  mdiAlert
};

export default icons;
